<template>
  <button :type="type" :style="cssProps">
    <p class="button-txt">{{ text }}</p>
    <fa class="icon" :icon="icon" />
  </button>
</template>

<script>
export default {
  name: "Button",
  props: {
    text: {
      type: String,
      default: "Button",
    },
    type: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "var(--primary-clr)",
    },
    icon: {
      type: String,
      default: "code",
    },
  },
  computed: {
    cssProps() {
      let display = "none";
      let txtClr = "";

      if (
        this.color == "white" ||
        this.color.toLowerCase() == "#ffffff" ||
        this.color.toLowerCase() == "#fff" ||
        this.color.toLowerCase() == "var(--light-clr)" ||
        this.color.toLowerCase() == "#0000" ||
        this.color.toLowerCase() == "transparent"
      ) {
        txtClr = "#454545";
      } else {
        txtClr = "white";
      }
      if (this.icon !== "code") {
        display = "block";
      }
      return {
        "--icon-display": display,
        "--btn-clr": this.color,
        "--txt-clr": txtClr,
      };
    },
  },
};
</script>

<style scoped>
button {
  border: none;
  background: var(--btn-clr);
  height: 2rem;
  border-radius: 3rem;
  box-shadow: 0 0 1rem 0.2rem rgba(126, 126, 126, 0.05);
  cursor: pointer;
  width: max-content;
  position: relative;
  overflow: hidden;
  transition: 0.5s ease;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

button::before {
  content: "";
  position: absolute;
  width: 0;
  aspect-ratio: 1;
  border-radius: 50%;
  background: var(--light-clr);
  opacity: 0.2;
  transition: 0.5s ease;
  /* justify-self: center;
  align-self: center; */
}

button:hover,
button:focus {
  box-shadow: 0 0 1rem 0.2rem rgba(0, 0, 0, 0.15);
}

button:hover::before,
button:focus::before {
  width: 110%;
}

.button-txt {
  color: var(--txt-clr);
  font-weight: bold;
  font-size: 1.2em;
  padding: 0rem 1.5rem;
  width: max-content;
}
.icon {
  margin-inline-end: 1.5rem;
  margin-inline-start: -1em;
  color: var(--txt-clr);
  display: var(--icon-display);
  transition: var(--transition);
  transform: scale(1);
}

button:hover .icon,
button:focus .icon {
  /* transform: scale(1.2); */
  animation-name: playfullCallToAction;
  animation-duration: 5s;
  animation-iteration-count: infinite;
}

@media screen and (max-width: 30rem) {
  .button-txt {
    font-size: 1em;
  }
}
</style>
